import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '../../../../shared/components/UI/Button/Button';
import { EmptyPlaceholder } from '../../../../shared/components/UI/EmptyPlaceholder/EmptyPlaceholder';

import { PermissionGuard } from '../../../../shared/components/PermissionGuard';
import { Permission } from '../../../../shared/entities/Access';

export function EmptyStreamPlaceholder() {
  const { t } = useTranslation('stream');
  return (
    <EmptyPlaceholder
      title={t('emptyStreamPlaceholder.title')}
      subtitle={t('emptyStreamPlaceholder.subtitle')}
      actionsComponent={<NewStreamButton />}
    />
  );
}

function NewStreamButton() {
  const { t } = useTranslation('stream');
  return (
    <PermissionGuard permission={Permission.CREATE_STREAM}>
      <Link to="/flux/create">
        <Button
          leftIcon={<IconPlus />}
          w="268px"
          radius="md"
          color="primary"
          mt={18}
          fz="14px"
          lh="34px"
          fw="600"
        >
          {t('emptyStreamPlaceholder.actionsComponent')}
        </Button>
      </Link>
    </PermissionGuard>
  );
}
